// This is just some sample data so you don't have to think of your own!
module.exports = {
  project1: {
    name: 'Brewzinga',
    image: 'http://res.cloudinary.com/dwv5f4wxv/image/upload/v1510701432/Screen_Shot_2017-11-14_at_3.15.34_PM_mt8blu.png',
    desc: 'Brewzinga organizes and delivers beer news from over 1900 places throughout the US based on your location',
    url: 'https://brewzinga.com',
    status: 'available'
  },
  project2: {
    name: 'Fox.com',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Fox_Broadcasting_Company_logo_%282019%29.svg/440px-Fox_Broadcasting_Company_logo_%282019%29.svg.png',
    desc: 'Single Page Application for Fox Content',
    url: 'https://www.fox.com',
    status: 'available'
  },

  project3: {
    name: 'Tic Tac Toe Game',
    image: 'https://assets.codepen.io/219170/internal/screenshots/pens/RZryvb.default.png?fit=cover&amp;format=auto&amp;ha=false&amp;height=720&amp;quality=75&amp;v=2&amp;version=1502304482&amp;width=1279',
    desc: 'FreeCodeCamp Project to create a tic tac toe game with AI',
    url: 'https://codepen.io/Camaromelt/full/RZryvb/',
    status: 'available'
  },

  project5: {
    name: 'Simon Says',
    image: 'https://assets.codepen.io/219170/internal/screenshots/pens/oeWMYq.default.png?fit=cover&amp;format=auto&amp;ha=true&amp;height=720&amp;quality=75&amp;v=2&amp;version=1503959016&amp;width=1279',
    desc: 'FreeCodeCamp Project to create a simon says game',
    url: 'https://codepen.io/camaromelt/full/oeWMYq/',
    status: 'available'
  },
  project6: {
    name: 'Javascript Calculator',
    image: 'https://assets.codepen.io/219170/internal/screenshots/pens/xLKXOL.default.png?fit=cover&amp;format=auto&amp;ha=false&amp;height=720&amp;quality=75&amp;v=2&amp;version=1501134304&amp;width=1279',
    desc: 'FreeCodeCamp: Javascript Calculator',
    url: 'https://codepen.io/camaromelt/pen/xLKXOL',
    status: 'available'
  },
  project7: {
    name: 'Twitch API',
    image: 'http://res.cloudinary.com/dwv5f4wxv/image/upload/v1510704249/Screen_Shot_2017-11-14_at_4.03.36_PM_hzes4f.png',
    desc: 'FreeCodeCamp Project to create a Twitch Status App',
    url: 'https://codepen.io/camaromelt/full/NjmNeb/',
    status: 'available'
  }
};



/** WEBPACK FOOTER **
 ** ./src/project-data.js
 **/